<template>
  <div>
    <b-container>
      <TheSummerMatchOverview :match="match" />
      <b-row class="pb-4">
        <b-col
          :cols="5"
          class="d-flex justify-content-center align-items-center"
        >
          <div class="d-flex justify-content-center">
            <BaseScoreInput
              :value="match.score_team1 === null ? '-' : match.score_team1"
              readonly="readonly"
            />
          </div>
        </b-col>
        <b-col
          :cols="2"
          :class="[
            'd-flex flex-column text-center align-items-center justify-content-center text-uppercase',
            $style.myPickText
          ]"
        >
          {{ $t('my-pick') }}
          <br>
          {{ myScorePredictions.team1score }}
          -
          {{ myScorePredictions.team2score }}
          <div
            v-if="isNoAthletePicked"
            class="d-flex flex-column align-items-center text-align-center pt-3"
          >
            <BaseAvatar :url="require('@/assets/images/avatar-gray.svg')" />
            <span
              :class="[
                'pt-1',
                $style.athleteName
              ]"
            >
              {{ $t('none') }}
            </span>
          </div>
          <div v-else-if="selectedAthletes.length">
            <template
              v-for="athlete in selectedAthletes"
            >
              <div
                :key="`athlete-${athlete.id}`"
                class="d-flex flex-column align-items-center text-align-center pt-3"
              >
                <BaseAvatar :url="athlete.image" />
                <span
                  :class="[
                    'pt-1',
                    $style.athleteName
                  ]"
                >
                  {{ athlete.name[$i18n.locale] }}
                </span>
              </div>
            </template>
          </div>
        </b-col>
        <b-col
          :cols="5"
          class="d-flex justify-content-center align-items-center"
        >
          <div class="d-flex justify-content-center">
            <BaseScoreInput
              :value="match.score_team2 === null ? '-' : match.score_team2"
              readonly="readonly"
            />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import BaseScoreInput from '@/pages/RoundDetail/Components/Atoms/BaseScoreInput'
import TheSummerMatchOverview from './TheSummerMatchOverview'
import BaseAvatar from '@/components/Atoms/BaseAvatar'

export default {
  name: 'TheClosedAndLiveSummerMatch',
  components: {
    BaseAvatar,
    TheSummerMatchOverview,
    BaseScoreInput,
  },
  props: {
    match: {
      type: Object,
      default: () => {},
    },
    myScorePredictions: {
      type: Object,
      default: () => ({
        team1score: null,
        team2score: null,
      }),
    },
    isNoAthletePicked: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    selectedAthletes() {
      return this.$store.getters['rounds/athletesInRound/getSelectedAthletesForRound'](this.match.round_id)
    },
  },
}
</script>

<style module lang="scss">
  @import "../../../../assets/scss/variables";
  .myPickText {
    white-space: nowrap;
    font-weight: 600;
  }
  .athleteName {
    font-weight: 400;
    font-size: $font-size-small;
    text-transform: none;
  }
</style>
